var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.918,
    height: 22.286,
    viewBox: "0 0 15.918 22.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M5.542,22.829l4.648-3.734a1.342,1.342,0,0,1,1.536,0l4.651,3.734a1.848,1.848,0,0,0,1.146.457,1.284,1.284,0,0,0,.578-.136,1.693,1.693,0,0,0,.817-1.6V3.465A2.43,2.43,0,0,0,16.531,1H5.388A2.43,2.43,0,0,0,3,3.465v18.08a1.692,1.692,0,0,0,.815,1.6A1.59,1.59,0,0,0,5.542,22.829ZM4.592,3.465a.809.809,0,0,1,.8-.822H16.531a.81.81,0,0,1,.8.822V21.509L12.7,17.8a2.882,2.882,0,0,0-3.489,0L4.592,21.509Z",
    transform: "translate(-3 -1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA);
export default __webpack_public_path__ + "static/media/a.36886345d3c92f14cc743f2c8936a8e5.svg";
export { ForwardRef as ReactComponent };